<template>

  <b-modal @hidden="onClose" @show="showModal" no-close-on-backdrop size="lg"
           :id="id"
           hide-footer
           title="Alteração do Mapeamento">

    <div>



      <div v-for="group in spotFolderOptions" :key="group.groupId">
        <b-card class="mb-3">
          <h5>{{ group.groupLabel }}</h5>

          <div v-for="option in group.options" :key="option.value" class="pl-3">
            <b-card class="mb-2" body-class="py-2 px-3">
              <b-card-title>{{ option.text }}</b-card-title>
              <EnterpriseEnvironment :origin-checklist-id="checklistId" :foreign-key="option.value" :spotFolder="option.text"/>
            </b-card>
          </div>

        </b-card>
      </div>


    </div>

  </b-modal>

</template>

<script>

import SpotFolderService from "@/services/modules/place/SpotFolder.service";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import EnterpriseEnvironment from "@/views/modules/place/EnterpriseEnvironment";

export default {
  mixins: [pageDialogFormMixin],
  components:{EnterpriseEnvironment},
  name: 'ChecklistChangeMapDialog',
  data() {
    return {
      id: "modal-checklist-change-map-dialog",
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      spotFolderOptions: [],
      //--------------------------------------------------------------------------------------
    }

  },
  props: {
    checklistId: {
      type: Number,
      default: 0,
    },
    enterpriseId: {
      type: Number,
      required: true,
    },
    businessTypeSurvey: Number,
    statusChecklist: Number,
  },
  methods: {

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async showModal() {

      this.busy = true

      await SpotFolderService.selectListGroupedByEnterpriseId(this.enterpriseId).then(list => this.spotFolderOptions = list)

      this.busy = false

    },
    //--------------------------------------------------------------------------------------

  },

}
</script>

